import InfoVM from './info-vm';
import InstructorCarousel from 'view_models/common/instructor-carousel'

export default {
  init: function() {
    // disable pjax so the course syllabus hero always and only shows up on the syllabus page
    $(document).pjax('a[href]:not([data-remote]):not([data-behavior]):not([data-skip-pjax]):not([target="_blank"]):not([href^="javascript"])', '[data-pjax-container]', {timeout: 1});

    // init the trianglify institution background
    var $el = $('.course-hero__partner-hero-wrapper');

    if ($el.length > 0) {
      var colors = $el.data('colors').trim().split(/[,\s]+/);

      if (colors.length && colors[0] != '' && colors.length > 1) {
        Kadenze.UIUtil.trianglify($el, colors, 40, 2, 'rgb', 0.88);
      } else if (colors.length == 1) {
        $el.css('background-image', 'none');
        $el.css('background-color', colors[0]);
      }

      // set the panel top border colors
      var panelBorderColor;

      if (colors[0] != '' &&
            colors[0].toLowerCase() != '#fff' &&
              colors[0].toLowerCase() != '#ffffff') {
        panelBorderColor = colors[0];
      } else {
        panelBorderColor = '#59d8e6';
      }

      $('.js-course-info-panel').css('border-top-color', panelBorderColor);
      $('#js-course-enroll-modal--options .modal-header').css('border-top-color', panelBorderColor);
    }

    // scroll the cta area up to the top of the viewport and fix it there
    var $container = $('.js-cta-container');
    var $footer = $('footer.kadenzec-footer').length > 0 ? $('footer.kadenzec-footer') : $('footer.site-footer');
    var $cta_wrapper = $('.js-course-hero__cta-wrapper');
    var $mobile_enroll_cta = $('.js-syllabus-enroll-sticky-header');
    var mobile_enroll_cta__offset_top = $mobile_enroll_cta.offset().top;

    var setScrolling = function(doc) {
      // set scrolling for the desktop floating cta area: .js-cta-container
      var $doc = $(doc);
      var cta_height = $cta_wrapper.outerHeight();
      var footerHeight = $footer.outerHeight();
      var documentHeight = $doc.height();
      var scrollTop = $doc.scrollTop();

      if ($doc.scrollTop() > 60) {
        $('body').addClass('fix-desktop-cta');
      } else {
        $('body').removeClass('fix-desktop-cta');
        $('body').removeClass('mobile-main-nav-shown');
      }

      // keep the cta module from overlapping the footer
      if ( scrollTop > (documentHeight - cta_height - footerHeight) ) {
        $container.css('top', -(scrollTop - (documentHeight - cta_height - footerHeight - 48)));
      } else {
        $container.attr('style', '');
      }
      // end footer overlap prevention

      // set tablet sticky enroll header cta
      if($doc.scrollTop() > mobile_enroll_cta__offset_top){
        $('body').addClass('fix-mobile-cta');
      } else {
        $('body').removeClass('fix-mobile-cta');
      }
      // end tablet sticky enroll header cta
    };

    $(document).off('scroll.fix-cta').on('scroll.fix-cta', _.debounce( function() {
      setScrolling(this);
    }, 10 ));

    // add listener for keydown so that the right panel adjusts while tabbing through the page as well as scrolling
    $(document).off('keydown.fix-cta').on('keydown.fix-cta', function() {
      setScrolling(this);
    });

    InstructorCarousel.init()

    // init the learning outcomes panel carousel
    var carouselConfig__learning_outcomes = {
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      autoplay: true,
      accessibility: false,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            arrows: false
          }
        }
      ],
      prevArrow: JST['templates/carousel-control__generic']({control_type: 'prev' }),
      nextArrow: JST['templates/carousel-control__generic']({control_type: 'next' })
    };

    var $carousel__outcomes_panel = $('.js-carousel_learninig-outcomes-panel');

    $carousel__outcomes_panel.on('init', function(slick){
      $carousel__outcomes_panel.find('.slick-slide').find('a, btn').attr('tabindex', '-1');
      $carousel__outcomes_panel.find('.slick-slide.slick-active').find('a, btn').attr('tabindex', '');
      $carousel__outcomes_panel.find('button.carousel-control__generic--prev').prependTo($carousel__outcomes_panel);
      $carousel__outcomes_panel.find('.slick-list').attr('aria-live', 'off');
      $carousel__outcomes_panel.find('.slick-dots button').prepend('carousel page');
      $carousel__outcomes_panel.find('.slick-dots li').attr('aria-hidden', 'false');
    });

    $carousel__outcomes_panel.on('afterChange', function(event, slick, currentSlide){
      $carousel__outcomes_panel.find('.slick-slide').find('a, btn').attr('tabindex', '-1');
      $carousel__outcomes_panel.find('.slick-slide.slick-active').find('a, btn').attr('tabindex', '');
      $carousel__outcomes_panel.find('.slick-dots li').attr('aria-hidden', 'false');
    });

    $carousel__outcomes_panel.slick(carouselConfig__learning_outcomes);

    var course_data = JSON.parse($('#course_json').val());

    // TODO : Refactor this whole mess.
    ko.applyBindings(new InfoVM(course_data), $('.js-syllabus-binding-target')[0]);

    Kadenze.WebApp.fbEventTrack('ViewContent', {
      content_category: 'course',
      content_type: 'product',
      content_ids: [course_data.id],
      content_name: course_data.name
    });

    ga('send', { hitType: 'event', eventCategory: 'course',
      eventAction: 'ViewContent', eventLabel: course_data.name
    });

    // pause carousel on focus
    $('body').off('focus.slickFocusPause').on('focus.slickFocusPause', '.slick-list', function(){
      $(this).parent().slick('slickPause');
    });

    // play carousel again on blur
    $('body').off('blur.slickFocusPause').on('blur.slickFocusPause', '.slick-list', function(){
      $(this).parent().slick('slickPlay');
    });

    // bind enroll modal events
    $('#js-course-enroll-modal--authenticate').on('shown.bs.modal', function(){
      setTimeout(function(){
        $('#js-course-enroll-modal--authenticate').find('input.form-control')[0].focus();
      }, 10);
      // setTimeout solves race condition with overarching modal focus event that sets focus to the first button in the modal
    });

    $('#js-course-enroll-modal--authenticate').on('hidden.bs.modal', function(){
      $('.course-hero__cta-btn').focus();
    });

    $('#js-course-enroll-modal--options').on('shown.bs.modal', function(){
      $('#js-course-enroll-modal--options').find('input')[0].focus();
    });

    $('#js-course-enroll-modal--options').on('hidden.bs.modal', function(){
      $('.js-enroll-btn').focus();
    });
  }
};
